export type FunctionInjectionTarget = {
  addOutput?: (...args: any[]) => void;
  addMetaoutput?: (...args: any[]) => void;
  addUserVariable?: (...args: any[]) => void;
  addSystemVariable?: (...args: any[]) => void;
  addFunction?: (...args: any[]) => void;
  closeSelector?: () => void;
  isAvailable?: () => boolean;
};

let activeFunctionInjectionTarget: FunctionInjectionTarget | null = null;

export function setActiveFunctionInjectionTarget(
  target: FunctionInjectionTarget
): void {
  activeFunctionInjectionTarget = target;
}

export function clearActiveFunctionInjectionTarget(
  target: FunctionInjectionTarget
): void {
  if (activeFunctionInjectionTarget === target) {
    activeFunctionInjectionTarget = null;
  }
}

export function getActiveFunctionInjectionTarget(): FunctionInjectionTarget | null {
  if (
    activeFunctionInjectionTarget?.isAvailable &&
    !activeFunctionInjectionTarget.isAvailable()
  ) {
    activeFunctionInjectionTarget = null;
  }

  return activeFunctionInjectionTarget;
}

export function getFunctionInjectionTarget(
  currentTarget: FunctionInjectionTarget,
  first: unknown,
  isNotFirstRender = true
): FunctionInjectionTarget {
  if (first !== false || isNotFirstRender === false) {
    return currentTarget;
  }

  const activeTarget = getActiveFunctionInjectionTarget();
  return activeTarget && activeTarget !== currentTarget
    ? activeTarget
    : currentTarget;
}

export function hasOpenFunctionSelector(): boolean {
  return Boolean(
    document.querySelector(
      '.drawer.is-open [data-function-selector-popper="true"]'
    )
  );
}
